import { IDataTableColumn } from "nsitools-react";
import * as React from "react";

import { SearchTablePage } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { PersonsKennelsApi, PersonKennelsGridDto, PersonKennelsSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { Link } from "react-router-dom";

export interface IPersonKennelsPageProps {
  personId: number;
}

export const PersonKennelsPage: React.FunctionComponent<IPersonKennelsPageProps> = ({ personId }) => {
  const api = useApiService(PersonsKennelsApi);
  const { t } = useTl();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "kennelName",
        render: (row: PersonKennelsGridDto) => (
          <Link target="_blank" to={`${ERoutes.kennel}/${row.kennelId}/detail/view`}>
            {row.kennelName}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.OwnerFrom),
        fieldName: "ownerFrom",
      },
      {
        header: () => t(ETLCodes.OwnerTo),
        fieldName: "ownerTo",
      },
    ],
    [t]
  );

  const search = React.useCallback(
    (sObj) => api.baseSearch(PersonKennelsSearch.fromJS({ ...sObj, personId: personId })),
    [api, personId]
  );

  return (
    <SearchTablePage
      title={t(ETLCodes.Kennels)}
      columns={columns}
      getCriteriasFunction={() => api.getSearchCriterias(true)}
      searchFunction={search}
      exportFunction={(sObj) => api.exportXlsFile(PersonKennelsSearch.fromJS({ ...sObj, personId: personId }))}
      sortKeys={{ ownerFrom: "ASC" }}
      saveCriterias={false}
      criteriaSavePrefix={"kennel"}
      //breadCrumbs={[{ text: t(ETLCodes.People) }]}
      withCard={false}
    />
  );
};
